module.exports = __webpack_public_path__ + "static/experts-make-the-case-for-college-index-8c3f23b432c03d6a6de51d7eddd5afd8.jpg";